import { render, staticRenderFns } from "./k-form-customize.vue?vue&type=template&id=cd1b03d6&scoped=true"
import script from "./k-form-customize.vue?vue&type=script&lang=js"
export * from "./k-form-customize.vue?vue&type=script&lang=js"
import style0 from "./k-form-customize.vue?vue&type=style&index=0&id=cd1b03d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd1b03d6",
  null
  
)

export default component.exports